import { render, staticRenderFns } from "./NavigationSearchInput.vue?vue&type=template&id=c0db640c&scoped=true&"
import script from "./NavigationSearchInput.vue?vue&type=script&lang=js&"
export * from "./NavigationSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSearchInput.vue?vue&type=style&index=0&id=c0db640c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db640c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Magnifier: require('/vercel/path0/components/icons/Magnifier.vue').default,Cross: require('/vercel/path0/components/icons/Cross.vue').default})
